import type { UnitModel } from '../../types';
import { initState, stepDynamic } from './dynamic';
import { solveSteady } from './steady';
import type {
  PumpPipelineInputs,
  PumpPipelineOutputs,
  PumpPipelineParams,
  PumpPipelineState,
  PumpPipelineStepOutputs,
} from './types';

/** Nasos + quvur tarmog'i + rostlash ventili — UnitModel. */
export const pumpPipeline: UnitModel<
  PumpPipelineParams,
  PumpPipelineInputs,
  PumpPipelineState,
  PumpPipelineStepOutputs,
  PumpPipelineOutputs
> = {
  id: 'pump-pipeline',
  init: (params, inputs) => initState(params, inputs),
  step: stepDynamic,
  steady: solveSteady,
};

export * from './types';
export * from './hydraulics';
export * from './pump';
export {
  solveSteady,
  systemContext,
  systemLosses,
  npshAvailable,
  operatingPoint,
  outputsAt,
  flowUpperBound,
  P_ATM,
} from './steady';
export { initState, stepDynamic, inertiaLength } from './dynamic';
